import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { fetchRemoteActions, addRemoteAction } from '../actions/remoteactions'
import { renderInputField, renderSelectField } from '../utils/forms'

class RemoteActionAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.submit = this.submit.bind(this)
  }

  submit(props) {
    // insert machine id to the query
    props.machine = this.props.machine._id
    props.executor = this.props.fullname

    return this.props.addRemoteAction(props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        // fetch remote actions so that they are refreshed
        this.props.fetchRemoteActions(this.props.machine._id)

        return response
      })
  }

  quickAction(code) {
    this.props.dispatch(change('RemoteActionAddForm', 'code', code))
    this.props.dispatch(change('RemoteActionAddForm', 'arguments', 'vacway'))
  }

  render() {
    const { error, pristine, submitting, handleSubmit, machine, fetchRemoteActions } = this.props

    const quickButtons = [
      { code: 'REBOOT',    label: 'Reiniciar',    icon: 'fa-power-off',  color: '#1d4ed8' },
      { code: 'DOOR_OPEN', label: 'Abrir Puerta', icon: 'fa-door-open',  color: '#059669' },
      { code: 'GET_MAC',   label: 'Solicitar MAC', icon: 'fa-network-wired', color: '#7c3aed' },
    ]

    return (
      <div className="od-remote-inner">
        {/* Quick action buttons */}
        <div className="od-remote-quick">
          <div className="od-remote-section-title">
            <i className="fas fa-bolt"></i> Acciones rápidas
          </div>
          <div className="od-remote-btn-row">
            {quickButtons.map(btn => (
              <button
                key={btn.code}
                type="button"
                className="od-remote-btn"
                style={{ '--btn-color': btn.color }}
                onClick={() => this.quickAction(btn.code)}
              >
                <span className="od-remote-btn-icon">
                  <i className={`fas ${btn.icon}`}></i>
                </span>
                <span className="od-remote-btn-label">{btn.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Advanced form */}
        <div className="od-remote-form-wrap">
          <div className="od-remote-section-title">
            <i className="fas fa-terminal"></i> Formulario avanzado
          </div>
          <div className="od-remote-alert">
            <i className="fas fa-exclamation-triangle"></i>
            Selecciona acciones directamente del formulario solo si sabes lo que haces, si no utiliza los botones predefinidos.
          </div>
          <form onSubmit={handleSubmit(this.submit)} className="od-remote-form">
            <div className="od-remote-fields-row">
              <Field name="code" component={renderSelectField}>
                <option value="">Selecciona una acción...</option>
                <option value="COMMAND">Ejecutar comando</option>
                <option value="REBOOT">Reiniciar máquina</option>
                <option value="DOOR_OPEN">Abrir puerta</option>
                <option value="UPDATE">Actualizar APP con UPDATER</option>
                <option value="UPDATER">Actualizar UPDATER</option>
                <option value="FIRMWARE">Actualizar FIRMWARE</option>
                <option value="ANYDESK">Iniciar Anydesk</option>
                <option value="GET_MAC">Solicitar MAC</option>
                <option value="SEND_LASTSALE">Enviar código de venta</option>
                <option value="SINGLE_COMMAND">Comando de terminal</option>
              </Field>
              <Field name="arguments" type="text" component={renderInputField} placeholder="Argumentos" />
            </div>
            <div className="od-remote-form-actions justify-content-center">
              <button className="od-remote-submit" type="submit" disabled={pristine || submitting}>
                <i className="fas fa-bolt"></i> Ejecutar
              </button>
              <button className="od-remote-refresh" type="button" onClick={() => fetchRemoteActions(machine._id)}>
                <i className="fas fa-sync"></i> Actualizar
              </button>
            </div>
            {error && <div className="od-remote-error">{error}</div>}
          </form>
        </div>
      </div>
    )
  }
}

RemoteActionAddForm = reduxForm({
  form: 'RemoteActionAddForm',
})(RemoteActionAddForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
  addRemoteAction: bindActionCreators(addRemoteAction, dispatch),
  fetchRemoteActions: bindActionCreators(fetchRemoteActions, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionAddForm)

